var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.9,
    height: 109.9,
    viewBox: "0 0 109.9 109.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8,0A18.3,18.3,0,0,0,27.5,18.3v4.6H50.4a4.6,4.6,0,0,1,0,9.1H18.3A18.3,18.3,0,0,0,0,50.4V68.7A18.3,18.3,0,0,0,18.3,87h4.6V64.1A13.7,13.7,0,0,1,36.6,50.4H73.3a4.6,4.6,0,0,0,4.5-4.6V18.3A18.3,18.3,0,0,0,59.5,0ZM41.2,9.2a4.6,4.6,0,1,1-4.6,4.5A4.6,4.6,0,0,1,41.2,9.2ZM87,22.9V45.8A13.7,13.7,0,0,1,73.3,59.5H36.6A4.7,4.7,0,0,0,32,64.1V91.6a18.3,18.3,0,0,0,18.4,18.3H64.1A18.3,18.3,0,0,0,82.4,91.6V87H59.5a4.6,4.6,0,0,1,0-9.2H91.6a18.3,18.3,0,0,0,18.3-18.3V41.2A18.3,18.3,0,0,0,91.6,22.9ZM68.7,91.6a4.6,4.6,0,1,1-4.6,4.5A4.6,4.6,0,0,1,68.7,91.6Z",
    style: {
      fill: "#19405e"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.ef9599d2e0caef1b5f247d4bf842cf48.svg";
export { ForwardRef as ReactComponent };